import { render } from "./MultiChoice.vue?vue&type=template&id=54ec8146"
import script from "./MultiChoice.vue?vue&type=script&lang=ts"
export * from "./MultiChoice.vue?vue&type=script&lang=ts"
script.render = render

export default script